import { TemplateDocument } from 'src/researcher/types/api';

export const blankTemplate = {
  // ! NOTE THAT _id empty is important for backend
  _id: '',
  id: '',
  name: 'Untitled Project',
  displayName: 'Blank Project',
  description: '',
  img: '',
  system: true,
  html: '',
};
